/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloLink, NextLink, Operation, FetchResult, Observable } from 'apollo-link';
import { PerformanceData } from './types';
import { performanceDataEmitter } from './emitters';

export const performanceDataLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  return new Observable<FetchResult>((observer) => {
    const sub = forward(operation).subscribe({
      next: (result) => {
        const extensions = (result as any)?.extensions;
        const dataToEmit: PerformanceData = {} as PerformanceData;

        // Handle mini_profiler
        const miniProfiler = extensions?.mini_profiler;
        if (miniProfiler?.data) {
          dataToEmit.miniProfiler = miniProfiler;
        }

        // Handle memory_profiler
        const memoryProfiler = extensions?.memory_profiler;
        if (memoryProfiler) {
          dataToEmit.memoryProfiler = memoryProfiler;
        }

        // Handle bullet_warnings
        const bulletWarnings = extensions?.bullet_warnings;
        if (Array.isArray(bulletWarnings)) {
          dataToEmit.bulletWarnings = bulletWarnings;
        }

        // Emit if anything was found
        if (Object.keys(dataToEmit).length > 0) {
          performanceDataEmitter.emit(dataToEmit);
        }

        observer.next(result);
      },
      error: (err) => observer.error(err),
      complete: () => observer.complete()
    });

    return () => {
      if (sub) sub.unsubscribe();
    };
  });
});
